import Form from './components/Form'
import { Table } from './components/Table'
import * as S from './ReservesTab.styles'

export default () => (
  <S.Wrapper>
    <Form />
    <Table />
  </S.Wrapper>
)
